import {Region, regionMap} from "./postcodeMap";
import config from "./config";

interface PostcodeRange {
  start: number;
  end: number;
}

const auPostcodeRegions: Record<string, PostcodeRange[]> = {
  NSW: [
    { start: 1000, end: 1999 },
    { start: 2000, end: 2599 },
    { start: 2619, end: 2899 },
    { start: 2921, end: 2999 },
  ],
  ACT: [
    { start: 200, end: 299 },
    { start: 2600, end: 2618 },
    { start: 2900, end: 2920 },
  ],
  VIC: [
    { start: 3000, end: 3999 },
    { start: 8000, end: 8999 },
  ],
  QLD: [
    { start: 4000, end: 4999 },
    { start: 9000, end: 9999 },
  ],
  SA: [
    { start: 5000, end: 5799 },
    { start: 5800, end: 5999 },
  ],
  WA: [
    { start: 6000, end: 6797 },
    { start: 6800, end: 6999 },
  ],
  TAS: [
    { start: 7000, end: 7799 },
    { start: 7800, end: 7999 },
  ],
  NT: [
    { start: 800, end: 899 },
    { start: 900, end: 999 },
  ],
};

const defaultRegions: Record<string, Region> = {
  AU: { postcode: "2020", region: "New South Wales", code: "NSW" },
  GB: { postcode: "", region: "England", code: "ENG" },
  US: { postcode: "90001", region: "California", code: "CA" },
};

export function postcodeToRegion(postcode: string, countryCode = config.countryCode) : Region {
  if (countryCode === "AU") {
    return auPostcodeToRegion(postcode);
  }

  if (countryCode === "GB") {
    return defaultRegions.GB;
  }

  if (countryCode === "US") {
    return defaultRegions.US;
  }

  if (postcode.length !== 4) {
    throw new Error('Postcode must have exactly four characters.');
  }

  const match = regionMap.find(mapping => mapping.postcode === postcode);

  if (!match) {
    throw new Error('No matching region for postcode prefix: ' + postcode);
  }

  return match;
}

function auPostcodeToRegion(postcode: string): Region {
  const postcodeNumber = parseInt(postcode, 10);
  if (postcode.length !== 4 || Number.isNaN(postcodeNumber) || postcodeNumber <= 0) {
    return defaultRegions.AU;
  }

  for (const [code, ranges] of Object.entries(auPostcodeRegions)) {
    const match = ranges.some((range) => postcodeNumber >= range.start && postcodeNumber <= range.end);
    if (match) {
      return {
        postcode,
        region: code,
        code,
      };
    }
  }

  return defaultRegions.AU;
}
